const FEATURE_BRANCH_MANAGER_COOKIE_NAME = 'branch';
const FEATURE_BRANCH_MANAGER_EXPIRY_TIME = 60000 * 60; // 1 Hour

const FEATURE_BRANCH_RESET_SELECTOR = '[data-click="featureBranchReset"]';
const FEATURE_BRANCH_SET_SELECTOR = '[data-click="featureBranchSet"]';

export default class FeatureBranchSwitcher {
    constructor(control) {
        this.component = control;

        const reset = control.querySelector(FEATURE_BRANCH_RESET_SELECTOR);
        if (reset) {
            reset.addEventListener('click', () => {
                this.resetToDefaultBranch();
            });
        }

        const set = control.querySelectorAll(FEATURE_BRANCH_SET_SELECTOR);
        set.forEach((setControl) => {
            setControl.addEventListener('click', (event) => {
                this.setFeatureBranch(event.target.dataset.branch);
            });
        });
    }

    setFeatureBranch(value) {
        const expiry = new Date(
            new Date().getTime() + FEATURE_BRANCH_MANAGER_EXPIRY_TIME
        );
        document.cookie = `${FEATURE_BRANCH_MANAGER_COOKIE_NAME}=${value}; expires=${expiry.toUTCString()}; path=/;`;
        window.location.reload();
    }

    resetToDefaultBranch() {
        const expiry = new Date();
        document.cookie = `${FEATURE_BRANCH_MANAGER_COOKIE_NAME}=; expires=${expiry.toUTCString()}; path=/;`;
        window.location.reload();
    }
}
